import * as bootstrap from 'bootstrap-5';

// https://github.com/twbs/bootstrap/issues/39408#issuecomment-2721536735
// Bootstrap treats offcanvas and modals the same so when an offcanvas is opened
// it grabs traps the focus to the offcanvas. This means when opening a modal with an 
// offcanvas still open we can't get focus on the modal so we can't interact with any form fields
// on it. This is typically solved by using enforceFocus={false} on the offcanvas component but if
// we load the page with the offcanvas already out there is a timing issue where the offcanvas still
// traps focus. Since we only currently use the offcanvas for the property slide outs on connect
// we can just override the focus trap to do nothing.
bootstrap.Offcanvas.prototype._initializeFocusTrap = function () {
  return { activate() {}, deactivate() {} };
};
